import { Helmet } from 'react-helmet'
import { REACT_APP_READER_URL } from 'env'
import { TWITTER_HANDLE, LOGO_URL } from 'utils/constants'
import { useBrand } from 'hooks/useBrand'

interface Props {
  url: string
  title: string
  imageUrl?: string
  description: string
  searchDescription?: string
  twitterLargeImage?: boolean
}

export const MetaTags = ({
  url,
  title,
  imageUrl = LOGO_URL,
  description,
  searchDescription,
  twitterLargeImage = false,
}: Props) => {
  const { name: brandName, longDescription: brandLongDescription } = useBrand()
  return (
    <Helmet>
      <title>{title}</title>
      {/* search description meta tag */}
      <meta name="description" content={searchDescription || description || brandLongDescription} />

      {/* open graph meta tags */}
      <meta property="og:url" content={url.startsWith(REACT_APP_READER_URL) ? url : REACT_APP_READER_URL + url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={imageUrl} />
      <meta property="og:site_name" content={brandName} />
      <meta property="og:type" content="website" />
      <meta property="og:locale" content="en_US" />

      {/* twitter meta tags */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={imageUrl} />
      <meta name="twitter:image:alt" content={title} />
      <meta name="twitter:card" content={twitterLargeImage ? 'summary_large_image' : 'summary'} />
      <meta name="twitter:site" content={TWITTER_HANDLE} />
    </Helmet>
  )
}
